import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import template from './myColors.jsx';
import compose from '../../hoc/compose';
import * as colorUtil from '../../util/color';
import displayNames from '../displayNames';

var getDistanceToWhite = function getDistanceToWhite(hexColor) {
  return _(hexColor).thru(colorUtil.hexToHsb).thru(colorUtil.getDistanceToWhite).value();
};

var MyColors = /*#__PURE__*/function (_React$Component) {
  _inherits(MyColors, _React$Component);

  var _super = _createSuper(MyColors);

  function MyColors(props) {
    var _this;

    _classCallCheck(this, MyColors);

    _this = _super.call(this, props);
    _this.state = _this.props.selectedIndex ? {} : {
      selectedIndex: _.indexOf(_this.props.colors, _this.props.value)
    };

    _this.getColorIndex = function () {
      return _.isNumber(_this.props.selectedIndex) ? _this.props.selectedIndex : _this.state.selectedIndex;
    };

    _this.getOptionClassNames = function (color, colorIndex) {
      return {
        light: getDistanceToWhite(color) < 3,
        'color-picker-my-colors-option': true,
        'selected-color': _this.getColorIndex() === colorIndex
      };
    };

    return _this;
  }

  _createClass(MyColors, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!this.props.selectedIndex) {
        this.setState({
          selectedIndex: _.indexOf(nextProps.colors, nextProps.value)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return MyColors;
}(React.Component);

MyColors.displayName = displayNames.MY_COLORS;
MyColors.propTypes = {
  value: PropTypes.string,
  selectedIndex: PropTypes.number,
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  onColorEnter: PropTypes.func,
  onColorLeave: PropTypes.func,
  addColor: PropTypes.func
};
MyColors.defaultProps = {
  onColorEnter: _.noop,
  onColorLeave: _.noop
};
export default compose(MyColors);